<template>
    <div class="kb-markdown-editor">
        <editor
            ref="editor"
            :initial-value="value || ''"
            :options="editorOptions"
            preview-style="tab"
            mode="wysiwyg"
            :height="height"
            initial-edit-type="wysiwyg"
            @change="onChange"
            @blur="onBlur"
        />
        <div
            v-if="hasDraft"
            class="kb-markdown-editor__indicators"
        >
            <kb-dot :title="$t('knowledgebase.unpublishedChanges')" />
            <kb-revert
                v-if="canRevert"
                @click="$emit('revert')"
            />
        </div>
    </div>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
import KbDot from './kb-dot.vue';
import KbRevert from './kb-revert.vue';

export default {
    name: 'kb-markdown-editor',

    components: {Editor, KbDot, KbRevert},

    props: {
        value: {
            type: String,
            default: '',
        },
        height: {
            type: String,
            default: '320px',
        },
        hasDraft: {
            type: Boolean,
            default: false,
        },
        canRevert: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            editorOptions: {
                // Pure WYSIWYG — markdown is the storage format only.
                hideModeSwitch: true,
                usageStatistics: false,
                toolbarItems: [
                    'heading',
                    'bold',
                    'italic',
                    'strike',
                    'divider',
                    'hr',
                    'quote',
                    'divider',
                    'ul',
                    'ol',
                    'task',
                    'divider',
                    'table',
                    'link',
                ],
            },
        };
    },

    methods: {
        onChange() {
            const md = this.$refs.editor.invoke('getMarkdown');
            // Toast appends a trailing newline to non-empty content. Trim only
            // that to avoid spurious draft-vs-published mismatches.
            const normalized = md.endsWith('\n') ? md.slice(0, -1) : md;
            if(normalized !== this.value) {
                this.$emit('input', normalized);
            }
        },
        onBlur() {
            this.$emit('blur');
        },
    },

    watch: {
        value(next) {
            if(!this.$refs.editor) return;
            const current = this.$refs.editor.invoke('getMarkdown');
            const trimmed = current.endsWith('\n') ? current.slice(0, -1) : current;
            if(next !== trimmed) {
                this.$refs.editor.invoke('setMarkdown', next || '');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.kb-markdown-editor {
    /* Toast styles its own toolbar; just give the surrounding box a border-radius
       consistent with the rest of cp-admin's form controls. */
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}

.kb-markdown-editor__indicators {
    /* Park the draft/revert indicators inside the toolbar row, flush right of
       the formatting buttons. The Toast toolbar is ~31px tall. */
    position: absolute;
    top: 0;
    right: 8px;
    height: 31px;
    display: flex;
    align-items: center;
    gap: 4px;
    pointer-events: none;
    z-index: 1;

    /* Re-enable interactivity for the revert button only. */
    > * {
        pointer-events: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-markdown-editor.vue